<template lang="pug">
    .intro_logo
        .logo_top
            .inner
                .atom_orbit
                    .atom
        .logo_bottom
            .inner
                .atom_orbit
                    .atom
        .logo_text(:class="{hide: popup==='mainPopup'}")
            img(src="@/assets/img/logo_text.png" alt="" :style="{opacity: screen=='intro_video'?0:1}")
            img(src="@/assets/img/logo_text_white.png" alt="" :style="{opacity: screen=='intro_video'?1:0}")
</template>

<script>
    export default {
        name: "IntroLogo",
        props: ['screen'],
        computed:{
            popup(){
                return this.$store.state.popup
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/scss/_functions.scss";
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/_mixins.scss";
    .intro_logo{
        transition: opacity 0s .7s;
        z-index: 55;
        @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
        }
        &.none{
            display: none;
        }
        &.open_popup{
            opacity: 1;
            transition: 0s;
        }
        &.inner:before{
            content: '';
            display: block;
            position: absolute;
            top: 52%;
            left: 37%;
            transform: translate(-50%, -50%);
            //width: 18rem;
            //height: 9rem;
            width: 14vw;
            height: 7.5vw;
            z-index: 100;
            @include razr1366{
                top: 54%;
                left: 38%;
                width: 22vw;
                height: 10.5vw;
            }
        }
        &.outer{
            pointer-events: none;
        }
        &.outer:not(.hide){
            transition: 0s;
        }
        &.hide{
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            opacity: 0;
            pointer-events: none;
        }
    }
    .logo_top, .logo_bottom {
        position: absolute;
        top: 50%;
        left: 47%;
        overflow: hidden;
        .inner{
            position: relative;
            width: 22vw;
            height: 20vw;
            background: url(../../assets/img/logo.png) no-repeat center center / contain;
        }
        .atom_orbit{
            position: absolute;
            top: 7%;
            left: 13%;
            z-index: -1;
            width: 18.3vw;
            height: 18.3vw;
            background: url(../../assets/img/logo_atom_circle.png) no-repeat center center / contain;
            .atom{
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                display: block;
                transform: rotate(26deg);
                &:after{
                    content: '';
                    display: block;
                    position: absolute;
                    top: 50%;
                    left: 0;
                    transform: translate(-50%, -50%);
                    width: 2.2vw;
                    height: 2.2vw;
                    background: url(../../assets/img/logo_atom.png) no-repeat center center / contain;
                }
            }
        }
    }

    .logo_top {
        z-index: 70;
        height: 7.7vw;
        transform: translate(-50%, -10vw);
    }

    .logo_bottom {
        z-index: 60;
        display: flex;
        align-items: flex-end;
        height: 14vw;
        transform: translate(-50%, -4vw);
        pointer-events: none;
    }

    .logo_text{
        position: absolute;
        top: 47.5%;
        left: 56.2%;
        z-index: 61;
        width: 17.6vw;
        pointer-events: none;
        transition: .4s .5s;
        img{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            transition: .5s .3s;
        }
        &.hide{
            opacity: 0;
            transition: .2s .3s;
        }
    }
    .mobile{
        .intro_logo.inner:before{
            display: none;
        }
        .logo_top, .logo_bottom, .logo_text{
            transition: top .8s;
        }
        .logo_top, .logo_bottom{
            top: 47%;
            left: 49%;
            .inner{
                width: 52vmin;
                height: 49vmin;
            }
            .atom_orbit{
                top: 13%;
                left: 13%;
                width: 41vmin;
                height: 41vmin;
                .atom:after{
                    width: 7.2vmin;
                    height: 7.2vmin;
                }
            }
        }
        .logo_top{
            height: 18.9vmin;
        }
        .logo_bottom{
            height: 30vmin;
            transform: translate(-50%, calc(9vw - 1px));
        }
        .logo_text{
            top: calc(47% + 33.7vw);
            left: 49.2%;
            width: 37vmin;
        }
        .intro_logo.up{
            .logo_top, .logo_bottom{
                top: 30%;
            }
            .logo_text{
                top: calc(30% + 33.7vw);
            }
        }
        @include tablet{
            .logo_text{
                top: calc(43% + 33.7vw);
            }
            .intro_logo.inner .logo_text{
                opacity: 0;
                transition: .1s;
            }
        }
        @include razr767{
            .intro_logo.inner .logo_text{
                opacity: 0;
                transition: .1s;
            }
        }
    }

</style>
